import { render, staticRenderFns } from "./SolutionEditor.vue?vue&type=template&id=34890752&scoped=true&"
import script from "./SolutionEditor.vue?vue&type=script&lang=ts&"
export * from "./SolutionEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SolutionEditor.vue?vue&type=style&index=0&id=34890752&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34890752",
  null
  
)

export default component.exports